import React from 'react';
import { InstagramIcon } from 'lucide-react';
import { contact, navLinks } from '../../data/site';
const footerNav = navLinks.filter(l => l.label !== 'Preguntas frecuentes');
export function Footer() {
  return <footer className="bg-teal-deep text-white" data-id="element-140" data-mp="2f3sbroch5tst">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-20" data-id="element-141" data-mp="2f2h5nhvk49yj">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-142" data-mp="2a6ic7fvdg1r9">
          <div data-id="element-143" data-mp="1mfcuev5vezeb">
            <p className="font-display text-[15px] font-semibold tracking-[0.16em]" data-id="element-144" data-mp="1mgxt8wz7x4hz">
              {contact.name.toUpperCase()}
            </p>
            <p className="mt-2 text-[13.5px] font-light text-white/60" data-id="element-145" data-mp="1w5z5qd6k13r7">{contact.title}</p>
            <p className="mt-1 eyebrow text-gold" data-id="element-146" data-mp="1w7sga3kag84h">{contact.npn}</p>
            <p className="mt-5 text-[13px] font-light text-beige" data-id="element-147" data-mp="1rdo7dergpq0r">
              Seguros de Vida <span className="text-gold" data-id="element-148" data-mp="13omvtinc1yr9">•</span> Salud{' '}
              <span className="text-gold" data-id="element-149" data-mp="yqleb25k27hw">•</span> Suplementales
            </p>
            <p className="mt-6 font-display text-[13px] font-medium italic text-beige" data-id="element-150" data-mp="yoh6i94jcocc">
              {contact.tagline}
            </p>
          </div>

          <nav aria-label="Navegación del pie de página" data-id="element-151" data-mp="1iim66b9z4t1c">
            <h2 className="eyebrow text-white/45" data-id="element-152" data-mp="1nadzuuoffevp">Navegación</h2>
            <ul className="mt-5 space-y-3" data-id="element-153" data-mp="1naxi6chzo5a9">
              {footerNav.map(l => <li key={l.href} data-id="element-154" data-mp="1s85rdnl5syzd">
                  <a href={l.href} className="text-[13.5px] font-light text-white/70 transition-colors duration-200 ease-out hover:text-beige" data-id="element-155" data-mp="1sblad1hyes62">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-156" data-mp="19ippowxqn0hd">
            <h2 className="eyebrow text-white/45" data-id="element-157" data-mp="19j980eravqvx">Contacto</h2>
            <ul className="mt-5 space-y-3" data-id="element-158" data-mp="19gmqbmap3uzz">
              <li data-id="element-159" data-mp="2fy029zlx4dgz">
                <a href={contact.phoneHref} className="text-[13.5px] font-light text-white/70 transition-colors duration-200 ease-out hover:text-beige" data-id="element-160" data-mp="2fyjk7gbkj1v0">
                  {contact.phoneDisplay}
                </a>
              </li>
              <li data-id="element-161" data-mp="1vbtt8kutga4d">
                <a href={contact.emailHref} className="break-all text-[13.5px] font-light text-white/70 transition-colors duration-200 ease-out hover:text-beige" data-id="element-162" data-mp="1qb5zvsj47h6z">
                  {contact.email}
                </a>
              </li>
              <li data-id="element-163" data-mp="20aetgka2itst">
                <a href={contact.instagramHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[13.5px] font-light text-white/70 transition-colors duration-200 ease-out hover:text-beige" data-id="element-164" data-mp="209v8eup4fpak">
                  <InstagramIcon size={15} strokeWidth={1.4} data-id="element-165" data-mp="1mb5e1mtos3pw" />
                  {contact.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8" data-id="element-166" data-mp="tr6pk8p5piy8">
          <p className="text-[11.5px] font-light leading-relaxed text-white/50" data-id="element-167" data-mp="osvjm91zfsla">
            <span className="font-medium text-white/70" data-id="element-168" data-mp="30gryhrvs1ugz">Disclaimer:</span> La información
            presentada en este sitio web tiene fines exclusivamente educativos e informativos y
            no constituye una oferta, contrato, garantía de cobertura ni asesoramiento
            financiero, legal o fiscal. La disponibilidad de productos, beneficios, tarifas,
            coberturas y compañías puede variar según el estado, elegibilidad, necesidades
            individuales y términos de cada póliza. Toda cobertura está sujeta a aprobación,
            suscripción y a los términos y condiciones establecidos por la compañía
            aseguradora. Para obtener información específica sobre una póliza, consulte los
            documentos contractuales correspondientes.
          </p>
          <p className="mt-6 text-[11.5px] font-light text-white/40" data-id="element-169" data-mp="1ys6fqb6r1qjo">
            © 2026 Andrea Báez Graterol. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}